<template>
  <section class="container content">
    <div class="resume-header">
      <h1 class="my-name">Amber Murphy</h1>
      <h2>QA Software Engineer</h2>
    </div>
    <skills class="section-margin" />
    <employment class="section-margin" />
    <education class="section-margin" />
  </section>
</template>

<script>
import Education from "./Education";
import Employment from "./Employment";
import Skills from "./Skills";

export default {
  name: "Resume",
  components: {
    Education,
    Employment,
    Skills
  }
};
</script>

<style>
.spacing {
  padding: 2em;
}
.resume-header {
  padding: 1em;
  width: 100%;
  margin: 0em auto;
  text-align: center;
}
.resume-header h1 {
  font-size: 2em;
  margin-bottom: 0;
}

.resume-header h2 {
  font-size: 1.35em;
  margin-top: 0;
}
</style>

<style>
.section-margin {
  margin-bottom: 1em;
}

.collapse-bar {
  display: inline;
}

.collapse-bar:hover {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  opacity: .5;
  transition: opacity .5s ease-out;
  
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
